export default "/assets/icons/pin-2d8cf0.svg"